import { render, staticRenderFns } from "./AggItem.vue?vue&type=template&id=70f17206&"
import script from "./AggItem.vue?vue&type=script&lang=js&"
export * from "./AggItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports